var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-layout',[_c('FormNav',{attrs:{"spamcount":_vm.spamCount}}),_vm._v(" "),_c('base-card',{staticClass:"space-y-4 mb-10 relative"},[_c('base-listing',_vm._b({},'base-listing',_vm.$props,false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }